import React from "react";
import { Link, NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../assets/logo.jpg"; // your Blue Shield Labs logo

export default function Navbar() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur bg-white/80 border-b border-blue-100 shadow-md">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        {/* Logo & Company Name */}
        <Link to="/" className="flex items-center gap-3">
          <img
            src={logo}
            alt="Blue Shield Labs Logo"
            className="h-12 w-auto drop-shadow-md"
          />
          <div>
            <div className="text-xl font-extrabold text-blue-700 tracking-tight">
              Blue Shield Labs
            </div>
            <div className="text-xs text-slate-500 -mt-1">
              The Lab Where Security & Talent Converge
            </div>
          </div>
        </Link>

        {/* Navigation Links */}
        <nav>
          <ul className="hidden md:flex items-center gap-6 text-sm font-medium">
            {[
              ["/", "Home"],
              ["/about", "About"],
              ["/services", "Services"],
              ["/careers", "Careers"],
              ["/contact", "Contact"],
            ].map(([to, label]) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    `py-2 px-3 rounded-md transition-all duration-200 ${
                      isActive
                        ? "bg-gradient-to-r from-blue-600 to-cyan-400 text-white shadow-md"
                        : "text-slate-700 hover:text-blue-600 hover:underline"
                    }`
                  }
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <motion.button
              whileTap={{ scale: 0.95 }}
              className="px-3 py-2 rounded-md bg-blue-600 text-white shadow-md"
              onClick={() => alert("Mobile menu — add drawer/menu here")}
            >
              Menu
            </motion.button>
          </div>
        </nav>
      </div>
    </header>
  );
}
